import UserBio from './UserBio';

export const components = {
  UserBio,
};
